import { render, staticRenderFns } from "./SntAutocompleteProduct.vue?vue&type=template&id=5d998fa2&scoped=true&"
import script from "./SntAutocompleteProduct.vue?vue&type=script&lang=js&"
export * from "./SntAutocompleteProduct.vue?vue&type=script&lang=js&"
import style0 from "./SntAutocompleteProduct.vue?vue&type=style&index=0&id=5d998fa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d998fa2",
  null
  
)

export default component.exports